import React, { useState } from 'react'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'
import I18n from '../../../resources/i18n/I18n'

const ModalImportCsv = ({ showModal, toggleModal, importCsv, type }) => {
  const [file, setFile] = useState(null)

  const handleSubmissionWithDryRun = (isDryRun) => {
    toggleModal()
    importCsv(file, isDryRun)
    setFile(null)
  }

  const onChangeFile = (e) => {
    setFile(e.target && e.target.files.length ? e.target.files[0] : null)
  }

  const capitalizedType = type.charAt(0).toUpperCase() + type.slice(1)

  return (
    <Modal show={showModal} onHide={toggleModal}>
      <Modal.Header closeButton>
        <Modal.Title>{I18n.t(`${capitalizedType}Import`)}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group>
          <Form.Control type="file" accept=".csv" onChange={onChangeFile} />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button
          className="btn-back"
          onClick={() => {
            toggleModal()
            setFile(null)
          }}
        >
          {I18n.t('ModalConfirmCancel')}
        </Button>

        <Button className="primary" onClick={() => handleSubmissionWithDryRun(true)} disabled={!file}>
          {I18n.t('ModalConfirmDryRun')}
        </Button>

        <Button className="primary" onClick={() => handleSubmissionWithDryRun(false)} disabled={!file}>
          {I18n.t('ModalConfirmOk')}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default ModalImportCsv
